/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnDestroy, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppConstants } from 'src/app/shared/constants/constants';
import { LoadingSpinnerService } from 'src/app/shared/service/loading-spinner.service';
import { SharingDataService } from 'src/app/shared/service/sharing-data.service';
import { ToastService, ToastType } from 'src/app/shared/service/toast.service';
import { TranslationService } from 'src/app/shared/service/translation.service';
import { ToastComponent } from "src/app/components/toast/toast.component";
import { FleetCardComponent } from "../fleet-card/fleet-card.component";
import { AddCarComponent } from "../add-car/add-car.component";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-fleets',
  templateUrl: './fleets.component.html',
  styleUrls: ['./fleets.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ToastComponent, FleetCardComponent, AddCarComponent, TranslateModule],
})
export class FleetsComponent implements OnInit, OnDestroy {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly _destroyRef = inject(DestroyRef);
  private readonly translationService = inject(TranslationService);
  private readonly sharingData = inject(SharingDataService);
  private readonly toastService = inject(ToastService);
  private readonly loadingSpinnerService = inject(LoadingSpinnerService);

  addCarClicked: boolean = false
  editCarClicked: boolean = false
  fleetCount: number = 0
  translationData: any;
  showToast: boolean = false;
  toastMessage: string = '';
  isSuccess: any;
  toastType: any = 0;
  position: any;
  leftPosition: any;
  updatedCarDetails: boolean = false
  childComponent: string = ''

  ngOnInit(): void {
    this.getToastMessages();
    this.toastMessageSubscription();
    this.handleCarAddedSubscription();
  }

  public getToastMessages(): void {
    this.toastService.toastDetails
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((status: any) => {
        this.showToast = status?.isShown;
        this.toastMessage = status?.message;
        this.toastType = status?.toastType;
        this.position = status?.position;
        this.leftPosition = status?.leftPosition;
        this.cdr.markForCheck();
      });
  }


  public toastMessageSubscription() {
    this.sharingData.getToasterToBeDisplayed()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((data) => {
        if (data) {
          this.showToast = true
          const toastMessage = 'BP_EM_ITEM_DELETED'
          this.toastService.show(ToastType.Success, `${toastMessage}`, "1%", "40%")
          setTimeout(() => {
            this.showToast = false
          }, AppConstants.MIN_TIME_TOASTER);
        }
      });
  }

  public handleCarAddedSubscription() {
    this.sharingData.getCarAddedSuccessfully()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((data) => {
        if (data) {
          this.showToast = true
          this.toastMessage = this.updatedCarDetails ? 'BP_PM_CAR_DETAILS_UPDATED' : 'BP_PM_CAR_ADDED_SUCCESSFULLY'
          this.toastService.show(ToastType.Success, `${this.toastMessage}`, "1%", "40%")
          setTimeout(() => {
            this.showToast = false
            this.updatedCarDetails = false
          }, AppConstants.MIN_TIME_TOASTER);
        }
      });
  }

  editCarDetailsEmitter(event: any) {
    if (event) {
      this.updatedCarDetails = true
    }
  }

  componentEmitter(event: string) {
    if (event) {
      this.childComponent = event
    }
  }

  addCar() {
    this.addCarClicked = true
    this.cdr.markForCheck();
  }

  cancelClicked(event: any) {
    if (event) {
      this.addCarClicked = false
    }
  }
  carCount(event: any) {
    this.fleetCount = event
  }

  ngOnDestroy(): void {
    this.sharingData.setCarAddedSuccessfully(false);
    this.sharingData.setToasterToBeDisplayed(false);
  }
}

